import { httpCreate } from './http';

const http = httpCreate('/srv/activityAdvert');

export const activityAdvert = {
	// 添加广告位
	addAdvert(id, data) {
		return http.post(`/${id}`, data);
    },
    //修改广告位
    upsetAdvert(advertId, data) {
        return http.put(`/${advertId}`, data);
    },
    //获取广告位列表
    getAdvertList(id) {
        return http.get(`/list/${id}`);
    },
    //删除广告位
    deleteAdvert(advertId) {
        return http.delete(`/${advertId}`);
    },
    //广告位修改排序
    updatePriority(data) {
        return http.post(`/updatePriority`, data);
    }
}